import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import GenerazioneOrario from './GenerazioneOrario';
import GenerazioneOrarioMobile from './GenerazioneOrarioMobile';

const isIPad = () => {
  if (typeof navigator === 'undefined') return false;
  return /iPad/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

/** Keeps the public route stable while selecting the touch calendar on phones/iPads. */
const GenerazioneOrarioRouter: React.FC = () => {
  const theme = useTheme();
  const narrowViewport = useMediaQuery(theme.breakpoints.down('md'));
  const forceDesktop = new URLSearchParams(window.location.search).get('desktop') === '1';

  return !forceDesktop && (narrowViewport || isIPad())
    ? <GenerazioneOrarioMobile />
    : <GenerazioneOrario />;
};

export default GenerazioneOrarioRouter;
